import { getMessage } from '@tcc/i18n';
import {
  Button,
  ButtonFill,
  ComponentAlign,
  ComponentColor,
  ComponentPadding,
  Container,
  DensitySpacing,
  Orientation,
  Spinner,
} from '@tcc/fds';
import { resizeModal } from '../../../../actions/modalActions';
import { ModalMode, ModalSize } from '../../../../types';
import { useAppDispatch } from '../../../../utils';

type Mode = string;
type IncorrectFileFormat = boolean;

type RegionNoteFormFooterProps = {
  modalMode: Mode;
  isLoading: boolean;
  confirmTitleKey: string;
  setDeleteConfirmationModal: (value: boolean) => void;
  handleCloseConfirmationClick: () => void;
  onSaveButtonClick: () => void;
  incorrectFileFormat: IncorrectFileFormat;
  isNewComment: boolean;
};

export const RegionNoteFormFooter = ({
  modalMode,
  isLoading,
  confirmTitleKey,
  setDeleteConfirmationModal,
  handleCloseConfirmationClick,
  onSaveButtonClick,
  incorrectFileFormat,
  isNewComment,
}: RegionNoteFormFooterProps) => {
  const dispatch = useAppDispatch();

  return (
    <Container orientation={Orientation.Horizontal} padding={ComponentPadding.None} gap={DensitySpacing.Together}>
      <Container justify={ComponentAlign.Start} padding={ComponentPadding.None} gap={DensitySpacing.Together}>
        <Button
          testId="region-note-form-delete"
          disabled={modalMode === ModalMode.ADD_REGION || isNewComment || isLoading}
          color={ComponentColor.Error}
          onClick={() => {
            dispatch(resizeModal(ModalSize.S));
            setDeleteConfirmationModal(true);
          }}
        >
          {isLoading ? <Spinner /> : getMessage(confirmTitleKey)}
        </Button>
      </Container>
      <Container justify={ComponentAlign.End}>
        <Button
          testId="region-note-form-cancel"
          fill={ButtonFill.Outline}
          color={ComponentColor.Primary}
          onClick={handleCloseConfirmationClick}
          disabled={isLoading}
        >
          {isLoading ? <Spinner /> : getMessage('cancel')}
        </Button>
        <Button
          testId="region-note-form-submit"
          disabled={isLoading || incorrectFileFormat}
          color={ComponentColor.Primary}
          onClick={onSaveButtonClick}
        >
          {isLoading ? <Spinner /> : getMessage('regions.report.modal.saveReport')}
        </Button>
      </Container>
    </Container>
  );
};
